import { RouteDefinition } from '../shared/navigation/route-definition';
import { RoutePaths } from '../shared/navigation/route-paths';
import { AlwaysShowRouteResolver } from '../shared/navigation/always-show-route-resolver';

export class PrintingRouteDefinition {
  public static getRoutes(): RouteDefinition {
    const menuItems: RouteDefinition = {
      path: RoutePaths.PRINTING,
      resolver: AlwaysShowRouteResolver,
      title: 'Printing',
      icon: 'icon-printers.svg',
      position: 8,
      children: [
        {
          path: RoutePaths.PRINTERS,
          parentPath: RoutePaths.PRINTING,
          title: 'Printers',
          position: 1
        },
        {
          path: RoutePaths.TEMPLATES,
          parentPath: RoutePaths.PRINTING,
          title: 'Printer Templates',
          position: 2
        },
        {
          path: RoutePaths.CASHDRAWERS,
          parentPath: RoutePaths.PRINTING,
          title: 'Cash Drawers',
          position: 3
        }
      ]
    };
    return menuItems;
  }
}
